import { InsuranceCms } from '@interfaces/directus-cms.interface';

export const insuranceCmsMock: InsuranceCms = {
    title: 'Je protège mon mobile',
    subtitle: 'Saviez-vous que la vitre avant d’un Smartphone coûte 309.90€',
    nuggets: {
        title: "Mon téléphone est réparé ou remplacé sans frais supplémentaires s'il est inutilisable en cas de :",
        data: [
            { label: 'casse', value: true },
            { label: 'vol', value: true },
            { label: 'oxydation suite à un contact avec un liquide', value: true },
            { label: 'panne', value: false },
            { label: 'perte', value: false },
        ],
        subtitle: "Une assurance qui va à l'essentiel, sans franchise, sans surprise.",
    },
    badge: 'Recommandé',
    renewLabel:
        'Si vous avez déjà une assurance pour votre ancien mobile, elle ne couvrira pas votre nouveau mobile.' +
        " Vous devrez contacter votre courtier gestionnaire de l'offre.",
    img: 'assets/checkout/insurance.jpg',
};
